export default __webpack_public_path__ + "media/ternary-badge.5b1e5118.png";